import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchema = Yup.object().shape({
    ordering: Yup.string().required('Ordenação é obrigatório'),
    className: Yup.string().required('Nome é obrigatória'),
});